// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"3e485565","450":"1da78e19","997":"541333a9"}[chunkId] + ".chunk.js";
};